<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="经销商名称">
              <el-input v-model="q.agentName" placeholder="请输入经销商名称" clearable />
            </el-form-item>
            <el-form-item label="渠道" prop="chanel">
<!--              <brselectlazy category="sales_region"-->
<!--                            v-model="q.channelCode"  :v="q.channelCode" :clearable="true"/>-->
              <el-select v-model="q.channelName" clearable placeholder="请选择" style="width:100%">
                <el-option v-for="item in qudaoList"
                           :key="item.code"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户名称">
              <el-input v-model="q.customerName" placeholder="请输入用户名称" clearable />
            </el-form-item>
            <el-form-item label="省份" prop="province">
              <brselect category="YlSalesArea_chanpin" :v="q.provinceCode" v-model="q.provinceCode" :clearable="true" />
<!--              <el-select v-model="q.provinceCode" filterable clearable-->
<!--                         placeholder="省" style="width: 100px;">-->
<!--                <el-option-->
<!--                    v-for="item in shenglist"-->
<!--                    :key="item.value"-->
<!--                    :label="item.name"-->
<!--                    :value="item.code">-->
<!--                </el-option>-->
<!--              </el-select>-->
            </el-form-item>
          </div>
          <div class="h-thirdColumn w-newColumn">
            <el-form-item  label="运营会日期" style="width: 50%;">
<!--              <el-date-picker-->
<!--                  placeholder="请选择开始时间"-->
<!--                  v-model="q.weekTimeStart"-->
<!--                  clearable-->
<!--                  type="date"-->
<!--                  value-format="yyyy-MM-dd" >-->
<!--              </el-date-picker>-->
<!--              <span class="w-time-to">至</span>-->
<!--              <el-date-picker-->
<!--                  placeholder="请选择结束时间"-->
<!--                  v-model="q.weekTimeEnd"-->
<!--                  clearable-->
<!--                  type="date"-->
<!--                  value-format="yyyy-MM-dd" >-->
<!--              </el-date-picker>-->
              <el-date-picker
                  v-model="value1"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changeTime"
              >
              </el-date-picker>
              <!--              <el-date-picker type="date" placeholder="选择日期" v-model="q.weekTime"-->
              <!--                              value-format="yyyy-MM-dd" style="width: 100%;">-->
              <!--              </el-date-picker>-->
            </el-form-item>
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleSearch">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
            ref="multipleTable"
            :data="tableData"
            :border="true"
            stripe
            max-height="560"
            style="width: 100%">
          <el-table-column
              label="序号"
              type="index"
              fixed
              width="70">
          </el-table-column>
          <el-table-column prop="provinceName" label="省份" width="100"></el-table-column>
<!--          <el-table-column prop="city" label="地市" width="100"></el-table-column>-->
          <el-table-column prop="channelName" label="渠道" width="100"></el-table-column>
          <el-table-column prop="agentName" label="经销商"  :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="customerName" label="用户名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="weekPlan" label="行动计划" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="weekTime" label="运营会日期" ></el-table-column>
          <el-table-column prop="cuname" label="创建人" ></el-table-column>
          <el-table-column prop="cdate" label="创建时间" ></el-table-column>
        </el-table>
        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
          <pagination :page="q" @query="query"/>
          <div style="display:flex;align-items: center;">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel()">批量导出
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "@/api/SystemService";
import weeklyMeetingApi from "@/api/loud/weeklyMeeting/weeklyMeetingApi";
import moment from "moment";
export default {
  data(){
    return{
      q:{
        agentName: '',//经销商名称
        channelName: '',//经销商渠道编码
        customerName: '',//用户名称
        provinceCode: '',//省份
        // weekTime: '',
        weekTimeStart: '',
        weekTimeEnd: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      qudaoLists: [],
      qudaoList: [],
      value1: []
    }
  },
  methods:{
    changeTime(val){
      this.q.weekTimeStart = moment(val[0]).format("YYYY-MM-DD");
      this.q.weekTimeEnd = moment(val[1]).format("YYYY-MM-DD");
    },
    //检索
    handleSearch(){
      this.q.pageNo = 1;
      this.query()
    },
    //查询
    query(){
      weeklyMeetingApi.selectPageDetailList(this.q).then(res=>{
        this.tableData = res.records
        this.q.total = res.total
      })
    },
    //重置
    handleReset(){
      this.q = {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
      this.value1 = []
      this.query()
    },
    //导出
    exportExcel(){
      let param = {
        agentName: this.q.agentName,//经销商名称
        channelCode: this.q.channelName,//经销商渠道编码
        customerName: this.q.customerName,//用户名称
        provinceCode: this.q.provinceCode,//省份
        weekTimeStart: this.q.weekTimeStart,
        weekTimeEnd: this.q.weekTimeEnd,
      }
      weeklyMeetingApi.pageDetailExport(param).then(res=>{
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', `未覆盖用户计划.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    //获取渠道
    getQudaoList() {
      ss.Dictservice.listbycategory("sales_region").then(rd => {
        this.qudaoList = rd;
        if(this.qudaoList){
          for (var i=0;i<this.qudaoList.length;i++){
            if( this.qudaoList[i].code<8){
              if(this.qudaoList[i].code != 5 && this.qudaoList[i].code != 6){
                this.qudaoLists.push(this.qudaoList[i]);
              }
            }
          }
        }
      })
    },
  },
  created() {
    this.getQudaoList();
    this.query()
  }
}
</script>
<style>

</style>